//@ts-check
import * as d3 from "d3";

/**
 * @module Highlight  
 */

/**
 * Applies highlight color to a group
 * @param {string} group_ID 
 */
export function applyHighlight(group_ID) {
  let scope = this;

  let group = scope.interaction.selectAll('#' + group_ID);
  
  // Store the original state of the element for later restoration
  if (group.attr('data-filtered') === 'true') {
    group.attr('data-was-filtered', true);
    group.attr('data-filtered-opacity', group.attr('data-opacity'));
  }
  
  if (group.attr('data-ghosted') === 'true') {
    group.attr('data-was-ghosted', true);
  }
  
  group.attr('data-isHov', true);
  scope.temp_highlight.push(group);
  scope.colorGroup(group, scope.highlightColor);

  var label = scope.overlay.selectAll('#' + group_ID);
  if ((label._groups && label._groups.length != 0) && (label._groups[0].length > 0)) {
    label.attr('data-isHov', true);
    scope.temp_highlight.push(label);
    scope.colorGroup(label, scope.highlightColor);
  }
}

/**
 * Enable or disable the highlighting functionality
 * @param {boolean} status If passed true value then enable highlighting. If passed false value then disable the highlighting functionality
 */
export function highlightCheck(status) {
  let scope = this;
  scope.highlightElementFlagCheck = status;
}

/**
 * Clears the highlighted element
 */
export function clear_highlightSelection() {
  let scope = this;
  if (scope.temp_highlight.length > 0) {
    scope.temp_highlight.forEach(group => {
      if (group._groups && (group._groups.length > 0) && (group._groups[0].length > 0)) {
        group.attr('data-isHov', false);

        var color = scope.hoverColor;
        
        // First check for active selection which takes precedence
        if (group.attr('data-isSel') === 'true') {
          color = scope.pickColor;
        }
        // Then check if it was previously filtered
        else if (group.attr('data-was-filtered') === 'true') {
          // Restore filtered state
          group.attr('data-filtered', true);
          let opacity = group.attr('data-filtered-opacity') || 0.3;
          group.selectAll(scope.types).style('opacity', opacity);
          // Restore color only if not a label
          if (group.attr('data-isLbl') !== 'true') {
            color = group.attr('data-color') || scope.hoverColor;
          }
          // Clean up temporary attribute
          group.attr('data-was-filtered', null);
        }
        // Then check if it was previously ghosted
        else if (group.attr('data-was-ghosted') === 'true') {
          // Restore ghosted state
          group.attr('data-ghosted', true);
          color = scope.ghostColor;
          // Clean up temporary attribute
          group.attr('data-was-ghosted', null);
        }
        // Special case for labels
        else if (group.attr('data-isLbl') === 'true') {
          color = scope.labelFillColor;
        }
        // Check if it has a custom color from colorBy
        else if (group.attr('data-isCol') === 'true') {
          color = group.attr('data-color');
        }
        
        scope.colorGroup(group, color);
      }
    });
  }
  scope.temp_highlight = [];
}

/**
 * Highlights to a single group
 * @param {string} group_ID 
 */
export function highlightedElement(group_ID) {
  let scope = this;
  scope.clear_highlightSelection();
  if (scope.interaction._groups && scope.interaction._groups.length != 0) {
    try {
      scope.applyHighlight(group_ID);
    } catch {
      //console.log('Error : Invalid element id. [ '+String(group_ID)+' ]'); 
    }
  } else {
    console.log('Error : Drawing is not loaded in viewer.');
  }
}

/**
 * Highlights to multiple group
 * @param {Array<string>} group_IDs - Array of the group Ids
 */
export function highlightedElements(group_IDs) {
  let scope = this;
  scope.clear_highlightSelection();
  group_IDs.forEach(group_ID => {
    if (scope.interaction._groups && scope.interaction._groups.length != 0) {
      try {
        scope.applyHighlight(group_ID);
      } catch {
        //console.log('Error : Invalid element id. [ '+String(group_ID)+' ]'); 
      }
    } else {
      console.log('Error : Drawing is not loaded in viewer.');
    }

  });
}